import Tooltip from '@anm/components/Tooltip';
import ChartBar, { CreateLabelParams } from '@anm/components/charts/ChartBar';
import { useCallback, useRef, FC } from 'react';
import { InfoLabel } from '@anm/styles/helpers';

import { CHART_BAR_MARGIN_RIGHT } from '..';
import { ChartTitle, ChartTitleWrapper, TitleRow } from '../Wrapper';
import { createLabels } from '../helpers';
import { useHeaderMaxWidth } from '../hooks';

import Wrapper, { ChartWrapper } from './Wrapper';

// TODO call from api when api is ready
const callToActionData = [
  { label: 'CTA-button clicks', value: 329 },
  { label: 'page visits', value: 2113 }
];

const chartHeight = 260;

const CallToActionChart: FC = () => {
  const callToActionChartRef = useRef<HTMLDivElement>(null);
  const containerWidth = useHeaderMaxWidth(
    callToActionChartRef,
    CHART_BAR_MARGIN_RIGHT
  );

  // TODO calc tooltip content
  const renderTooltipContent = useCallback(
    () => (
      <span>
        Out of 2115 people who <br />
        loaded the page,<b>676</b> <br /> <b>(32%)</b> have clicked on the
        <br />
        CTA-button.
      </span>
    ),
    []
  );

  // TODO calc value with api response
  const value = '15.6%';

  const createLabelsHandler = useCallback(
    (params: CreateLabelParams) => createLabels(params),
    []
  );

  // TODO hide till implement on BE
  if (true) return null;

  return (
    <Wrapper ref={callToActionChartRef}>
      <TitleRow maxWidth={containerWidth}>
        <ChartTitleWrapper>
          <ChartTitle title="Call to action funnel" level={4} />
          <Tooltip direction="to-top" renderContent={renderTooltipContent}>
            <InfoLabel />
          </Tooltip>
        </ChartTitleWrapper>
        <span>{value}</span>
      </TitleRow>
      <ChartWrapper>
        <ChartBar
          barMargin={30}
          variant="vertical"
          height={chartHeight}
          data={callToActionData}
          chartWidthRatio={5 / 6}
          barsVerticalPadding={40}
          drawTooltipOrLabels={createLabelsHandler}
          containerRef={callToActionChartRef}
          margin={{ bottom: 30, right: CHART_BAR_MARGIN_RIGHT }}
        />
      </ChartWrapper>
    </Wrapper>
  );
};

export default CallToActionChart;
